// React imports
import React, { useContext } from 'react';

// Third party imports
import { Table } from 'reactstrap';

// Context imports
import { AdminContext } from '../../../../Context/Exports/ContextExports';

export default function PaymentAttempts({ paymentAttempts }) {
  const { superUser } = useContext(AdminContext);

  if (!superUser || !paymentAttempts || paymentAttempts.length === 0) {
    return null;
  }

  return (
    <div className="mt-4">
      <h6 className="fw-bold">Payment Attempts</h6>
      <Table responsive bordered striped size="sm">
        <thead>
          <tr>
            <th>Date</th>
            <th>Charge ID</th>
            <th>Service</th>
            <th>Amount</th>
            <th>Card</th>
            <th>Paid By</th>
            <th>Sync Status</th>
          </tr>
        </thead>
        <tbody>
          {paymentAttempts.map((attempt) => (
            <tr key={attempt.id}>
              <td>{attempt.created_at}</td>
              <td><code>{attempt.charge_id}</code></td>
              <td>{attempt.service_type}</td>
              <td>{attempt.amount_paid}</td>
              <td>
                {attempt.card_brand && attempt.card_last4
                  ? `${attempt.card_brand} ****${attempt.card_last4}`
                  : 'N/A'}
              </td>
              <td>
                {attempt.paid_by_name || attempt.paid_by_email || 'N/A'}
              </td>
              <td>{attempt.sync_status?.replace(/_/g, ' ')}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
